import type { DataSourceOption, Gender } from "./types";

export interface NetworkSelectOption {
	value: string;
	label: string;
	logo: string | null;
	country: string | null;
	teamCount: number;
	gender: string | null;
	isSelectable: boolean;
}

export function toNetworkSelectOptions(options: DataSourceOption[]): NetworkSelectOption[] {
	return options.map((option) => ({
		value: option.key,
		label: option.label,
		logo: option.logo ?? null,
		country: option.country ?? null,
		teamCount: option.teamCount ?? 0,
		gender: deriveNetworkGenderLabel(option),
		isSelectable: option.isSelectable,
	}));
}

function deriveNetworkGenderLabel(option: DataSourceOption): string | null {
	const genders = option.genders;
	if (genders === undefined) {
		return null;
	}

	const maleAvailable = genders.male.available;
	const femaleAvailable = genders.female.available;

	if (maleAvailable && femaleAvailable) {
		return null;
	}

	if (maleAvailable) {
		return "Male" satisfies Gender;
	}

	if (femaleAvailable) {
		return "Female" satisfies Gender;
	}

	return null;
}
